module.exports = __WEBPACK_EXTERNAL_MODULE_106__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}
// module id = 106
// module chunks = 0